import { getWindow } from "@faire/globals/browser/getWindow";

/** Hook-free window dimensions for sync reads in event handlers. */
export const getWindowWidth = (): number => getWindow()?.innerWidth ?? 0;

export const getWindowHeight = (): number => getWindow()?.innerHeight ?? 0;
